import { Outlet, ScrollRestoration } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useHreflang } from "@/hooks/useHreflang";
import { useLanguageFromUrl } from "@/hooks/useLanguageFromUrl";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CookieBanner } from "@/components/CookieBanner";

export const RootLayout = () => {
  useLanguageFromUrl();
  useHreflang();

  return (
    <>
      <ScrollRestoration />
      {/* Antes del contenido: es lo primero a lo que llega el teclado mientras no haya elección */}
      <CookieBanner />
      <Outlet />
      <Toaster />
      <WhatsAppButton />
    </>
  );
};
